/* --- Made by justgoscha and licensed under MIT license --- */

var app = angular.module('autocomplete', []);

app.directive('autocomplete', function() {
  var index = -1;

  return {
    restrict: 'E',
    scope: {
      searchParam: '=ngModel',
      suggestions: '=data',
      onType: '=onType',
      onSelect: '=onSelect',
      onEnter: '=onEnter',
      autocompleteRequired: '=',
      //searchMode: '='
    },
    controller: ['$scope', function($scope){
      // the index of the suggestions that's currently selected
      $scope.selectedIndex = -1;

      $scope.initLock = true;

      // set new index
      $scope.setIndex = function(i){
        $scope.selectedIndex = parseInt(i);
      };

      this.setIndex = function(i){
        $scope.setIndex(i);
        $scope.$apply();
      };

      $scope.getIndex = function(i){
        return $scope.selectedIndex;
      };

      // watches if the parameter filter should be changed
      var watching = true;

      // autocompleting drop down on/off
      $scope.completing = false;

      // starts autocompleting on typing in something
      $scope.$watch('searchParam', function(newValue, oldValue){

        if (oldValue === newValue || (!oldValue && $scope.initLock)) {
          return;
        }

        if(watching && typeof $scope.searchParam !== 'undefined' && $scope.searchParam !== null) {
          $scope.completing = true;
          $scope.searchFilter = $scope.searchParam;
          $scope.selectedIndex = -1;
        }

        // function thats passed to on-type attribute gets executed
        if($scope.onType)
          $scope.onType($scope.searchParam);
      });

      // for hovering over suggestions
      this.preSelect = function(suggestion){

        watching = false;

        // this line determines if it is shown
        // in the input field before it's selected:
        //$scope.searchParam = suggestion;

        $scope.$apply();
        watching = true;

      };

      $scope.preSelect = this.preSelect;

      this.preSelectOff = function(){
        watching = true;
      };

      $scope.preSelectOff = this.preSelectOff;

      // selecting a suggestion with RIGHT ARROW or ENTER
      $scope.select = function(suggestion){
        if(suggestion){
          $scope.searchParam = suggestion;
          $scope.searchFilter = suggestion;
          if($scope.onSelect)
            $scope.onSelect(suggestion);
        }

        watching = false;
        $scope.completing = false;
        setTimeout(function(){watching = true;},1000);
        $scope.setIndex(-1);
      };


    }],
    link: function(scope, element, attrs){


      setTimeout(function() {
        scope.initLock = false;
        scope.$apply();
      }, 250);

      var attr = '';

      // Default atts
      scope.attrs = {
        "placeholder": "start typing...",
        "class": "",
        "id": "",
        "inputclass": "",
        "inputid": ""
      };

      for (var a in attrs) {
        attr = a.replace('attr', '').toLowerCase();
        // add attribute overriding defaults
        // and preventing duplication
        if (a.indexOf('attr') === 0) {
          scope.attrs[attr] = attrs[a];
        }
      }

      if (attrs.clickActivation) {
        element[0].onclick = function(e){
          if(!scope.searchParam){
            setTimeout(function() {
              scope.completing = true;
              scope.$apply();
            }, 200);
          }
        };
      }

      var key = {left: 37, up: 38, right: 39, down: 40 , enter: 13, esc: 27, tab: 9};

      document.addEventListener("keydown", function(e){
        var keycode = e.keyCode || e.which;

        switch (keycode){
          case key.esc:
            // disable suggestions on escape
            scope.select();
            scope.setIndex(-1);
            scope.$apply();
            e.preventDefault();
        }
      }, true);

      document.addEventListener("blur", function(e){
        // disable suggestions on blur
        // we do a timeout to prevent hiding it before a click event is registered
        setTimeout(function() {
          scope.select();
          scope.setIndex(-1);
          scope.$apply();
        }, 150);
      }, true);

     //element[0].querySelector('input').addEventListener("focus", function(e){
     //  scope.searchMode = true;
     //}, true);

      element[0].addEventListener("keydown",function (e){
        var keycode = e.keyCode || e.which;

        var l = angular.element(this).find('li').length;

        // this allows submitting forms by pressing Enter in the autocompleted field
        if(!scope.completing || l == 0) return;

        // implementation of the up and down movement in the list of suggestions
        switch (keycode){
          case key.up:

            index = scope.getIndex()-1;
            if(index<-1){
              index = l-1;
            } else if (index >= l ){
              index = -1;
              scope.setIndex(index);
              scope.preSelectOff();
              break;
            }
            scope.setIndex(index);

            if(index!==-1)
              scope.preSelect(angular.element(angular.element(this).find('li')[index]).text());

            scope.$apply();

            break;
          case key.down:
            index = scope.getIndex()+1;
            if(index<-1){
              index = l-1;
            } else if (index >= l ){
              index = -1;
              scope.setIndex(index);
              scope.preSelectOff();
              scope.$apply();
              break;
            }
            scope.setIndex(index);

            if(index!==-1)
              scope.preSelect(angular.element(angular.element(this).find('li')[index]).text());

            break;
          case key.left:
            break;
          case key.right:
          case key.enter:
          case key.tab:
            index = scope.getIndex();
            // scope.preSelectOff();
            if(index !== -1) {
              scope.select(angular.element(angular.element(this).find('li')[index]).text());
              if(keycode == key.enter) {
                e.preventDefault();
              }
            } else {
              if(keycode == key.enter) {
                scope.select();
                if(scope.onEnter)
                  scope.onEnter();
              }
            }
            scope.setIndex(-1);
            scope.$apply();

            break;
          case key.esc:
            // disable suggestions on escape
            scope.select();
            scope.setIndex(-1);
            scope.$apply();
            e.preventDefault();
            break;
          default:
            return;
        }

      });
    },
    template: '\
        <div class="autocomplete {{ attrs.class }}" id="{{ attrs.id }}">\
        <label for="{{ attrs.inputid}}"></label>\
          <input\
            type="text"\
            ng-model="searchParam"\
            placeholder="{{ attrs.placeholder }}"\
            class="{{ attrs.inputclass }}"\
            id="{{ attrs.inputid }}"\
            ng-required="{{ autocompleteRequired }}" />\
          <ul ng-show="completing && (suggestions | filter:searchFilter).length > 0">\
            <li\
              suggestion\
              ng-repeat="suggestion in suggestions | filter:searchFilter | orderBy:\'toString()\' track by $index"\
              index="{{ $index }}"\
              val="{{ suggestion }}"\
              ng-class="{ active: ($index === selectedIndex) }"\
              ng-click="select(suggestion)"\
              ng-bind-html="suggestion | highlight:searchParam"></li>\
          </ul>\
        </div>'
  };
});

app.filter('highlight', ['$sce', function ($sce) {
  return function (input, searchParam) {
    if (typeof input === 'function') return '';
    if (searchParam) {
      var words = '(' +
            searchParam.split(/\ /).join(' |') + '|' +
            searchParam.split(/\ /).join('|') +
          ')',
          exp = new RegExp(words, 'gi');
      if (words.length) {
        input = input.replace(exp, "<span class=\"highlight\">$1</span>");
      }
    }
    return $sce.trustAsHtml(input);
  };
}]);

app.directive('suggestion', function(){
  return {
    restrict: 'A',
    require: '^autocomplete', // ^look for controller on parents element
    link: function(scope, element, attrs, autoCtrl){
      element.bind('mouseenter', function() {
        autoCtrl.preSelect(attrs.val);
        autoCtrl.setIndex(attrs.index);
      });

      element.bind('mouseleave', function() {
        autoCtrl.preSelectOff();
      });
    }
  };
});

/* ng-infinite-scroll - v1.0.0 - 2013-02-23 */
var mod;mod=angular.module("infinite-scroll",[]),mod.directive("infiniteScroll",["$rootScope","$window","$timeout",function(i,n,e){return{link:function(t,l,o){var r,c,f,a;return n=angular.element(n),f=0,null!=o.infiniteScrollDistance&&t.$watch(o.infiniteScrollDistance,function(i){return f=parseInt(i,10)}),a=!0,r=!1,null!=o.infiniteScrollDisabled&&t.$watch(o.infiniteScrollDisabled,function(i){return a=!i,a&&r?(r=!1,c()):void 0}),c=function(){var e,c,u,d;return d=n.height()+n.scrollTop(),e=l.offset().top+l.height(),c=e-d,u=n.height()*f>=c,u&&a?i.$$phase?t.$eval(o.infiniteScroll):t.$apply(o.infiniteScroll):u?r=!0:void 0},n.on("scroll",c),t.$on("$destroy",function(){return n.off("scroll",c)}),e(function(){return o.infiniteScrollImmediateCheck?t.$eval(o.infiniteScrollImmediateCheck)?c():void 0:c()},0)}}}]);
(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Hues/Breadcrumbs/_breadcrumbs.tpl.html',
    '<div class="filter-current"><h3><span ng-repeat="crumb in breadcrumbs.breadcrumbs" ng-if="crumb"><strong class="title {{breadcrumbs.current_color}}">{{crumb}}</strong></span></h3></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Hues/Single/_single-hue.tpl.html',
    '<div class="open-hue"><div class="hue-content"><div class="pallete" ng-style="{\'background-color\': hue.hue_hexadecimal ? \'#\'+hue.hue_hexadecimal : \'\', \'background-image\': hue.texture ? \'url(\'+hue.texture+\')\' : hues.texture ? \'url(\'+hues.texture+\')\' : hue.hue_img ? \'url(\'+hue.hue_img+\')\' : \'\'}"></div><div class="info"><span class="close-hue"><a ng-if="hue.redirect" class="back" ng-href="{{hue.redirect}}">חזרה</a> <i class="close na-close"></i></span><div class="details"><h1 class="ng-binding">{{hue.hue_code}}</h1><h2 class="ng-binding">{{hue.name}}</h2><span class="ng-binding">שייך למניפת: {{hue.fan}}</span></div><div class="actions"><ul class="wishlist"><li><i class="na-drop-small" data-wishlist="samples" data-id="{{hue.ID}}" data-fan="{{hue.neutral_fan_id ? hue.neutral_fan_id : hues.neutral_fan_id ? hues.neutral_fan_id : null}}"></i> הוספה לדוגמאות</li><li><i class="na-heart-small" data-wishlist="hues" data-id="{{hue.ID}}"></i> הוספה למועדפים</li></ul><ul class="mini"><li><a ng-href="{{hue.print_url}}" target="_blank"><i class="na-print"></i><span>הדפסה</span></a></li><li><a ng-href="mailto:?Subject={{hue.name}}&amp;body={{hue.mail_url}}"><i class="na-mail"></i><span>שליחה במייל</span></a></li><li><i class="na-share" data-share="hue" data-slug="{{hue.slug}}" data-fan="{{hue.neutral_fan_id ? hue.neutral_fan_id : hues.neutral_fan_id ? hues.neutral_fan_id : null}}"></i><span>שיתוף</span></li></ul></div><div class="hues-btn"><div ng-if="!hue.nextBtn"><button ng-click="hue.nextBtn = true" class="go-next-btn button">שמירת גוון ומוצרים מתאימים</button></div><div ng-if="hue.nextBtn"><p>את הגוון הנבחר ניתן לשמור במועדפים למועד מאוחר יותר, או לבחור לו מוצר מתאים ולקנות ברגע זה</p><button class="button transparent" data-wishlist="hues" data-id="{{hue.ID}}">הוספה למועדפים</button> <a href="{{hues.CATALOG_URL + \'/\' + ( hue.hue_code | spaceless )}}" class="button" onclick="GA.send(\'Shades Fan\', \'Suitable products\');">למוצרים מתאימים</a></div></div></div></div></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Filters/Categories/Templates/_category.tpl.html',
    '<a ui-state="category_state.state" ui-state-params="{category_slug: category.slug}" class="swiper-slide" ui-sref-active="current" ui-state-opts="{ reload: true }"><i class="{{category.class}}"></i> <span>{{category.name}}</span></a>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Filters/Categories/Views/_categories.tpl.html',
    '<div id="type" class="filter-strip"><div class="swiper-outer"><div class="swiper-container"><div class="swiper-wrapper"><category ng-repeat="category in categories.categories" swiper></category></div></div></div><div class="swiper-button-next"></div><div class="swiper-button-prev"></div></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Filters/Color-Fans/Templates/_color-fan.tpl.html',
    '<li class="swiper-slide" ui-sref-active="current"><a ui-sref="^.colors({color_fan_slug: fan.slug})" ui-sref-opt="{ reload: true }" onclick="GA.send(\'Shades Fan\', \'Filter by Fan\');"><span title="{{fan.name}}">{{fan.name}}</span></a></li>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Filters/Color-Fans/Views/_color-fans.tpl.html',
    '<div id="fan" class="filter-strip {{filters.current_color}}"><div><span>הצגת מניפה:</span><div class="swiper-outer"><div class="swiper-container"><ul class="swiper-wrapper"><li class="all swiper-slide" ui-sref-active="current"><a ui-sref="{color_fan_slug: null}" onclick="GA.send(\'Shades Fan\', \'Filter by Fan\');"><span title="כל מניפות הגוונים">כל מניפות הגוונים</span></a></li><color-fan ng-repeat="fan in color_fans.color_fans" swiper></color-fan></ul></div><div class="swiper-button-next"></div><div class="swiper-button-prev"></div></div></div></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Filters/Effect-Fans/Templates/_effect-fan.tpl.html',
    '<a ui-state="effect_fan_state.state" ui-state-params="{effect_fan_slug: fan.slug}" ui-sref-active="current" ui-state-opts="{ reload: true }" class="swiper-slide"><i style="background-image: url({{fan.img}})"></i> <span title="{{fan.name}}">{{fan.name}}</span></a>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Filters/Effect-Fans/Views/_effect-fans.tpl.html',
    '<div id="effect" class="filter-strip {{filters.current_color}}"><div class="swiper-outer"><div class="swiper-container"><div class="swiper-wrapper"><a ui-sref="main.categories.families.effects({effect_fan_slug: null})" ui-sref-opts="{ reload: true }" class="swiper-slide all" ui-sref-active="current"><i class="na-categories-all"></i> <span>כל סוגי האפקטים</span></a><effect-fan ng-repeat="fan in effect_fans.effect_fans" swiper></effect-fan></div></div></div><div class="swiper-button-next"></div><div class="swiper-button-prev"></div></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Filters/Families/Templates/_family.tpl.html',
    '<a ui-sref="{family_slug: family.slug}" ui-sref-active="current" class="swiper-slide" onclick="GA.send(\'Shades Fan\', \'Filter by Shade\');"><i class="{{family.slug}}"></i> <span>{{family.name}}</span></a>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Filters/Families/Views/_families.tpl.html',
    '<div id="color" class="filter-strip {{filters.current_color}}"><div class="swiper-outer"><div class="swiper-container"><div class="swiper-wrapper"><a ui-sref="{family_slug: null}" class="all colorful swiper-slide" ui-sref-active="current" onclick="GA.send(\'Shades Fan\', \'Filter by Shade\');"><i class="na-categories-all"></i> <span>כל הגוונים</span></a><family ng-repeat="family in families.families" swiper></family></div></div></div><div class="swiper-button-next"></div><div class="swiper-button-prev"></div></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Filters/Main/Views/_Filters.tpl.html',
    '<div id="filters" class="no-underline" ng-class="{\'open\': filters.filterOn}"><div ui-view="categories" class="filter-strip"></div><div ui-view="inner-filters" is-resolve style="min-height: 100px"></div></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Filters/Main/Views/_inner-filters.tpl.html',
    '<div ui-view="families" ng-class="{\'filter-strip\': families.families.length}"></div><div ui-view="effect" ng-class="{\'filter-strip\': effect_fans.effect_fans.length}"></div><div ui-view="color-fans" ng-class="{\'filter-strip\': color_fans.color_fans.length}"></div><div ui-view="sub-categories"></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Filters/Mobile-Filters/Views/_mobile-filter.tpl.html',
    '<nav id="filter-categories" class="filter-strip" swiper><div class="swiper-outer"><div class="swiper-container"><ul class="swiper-wrapper"><li class="swiper-slide"><a ng-click="mobile.toggleFilters(\'filterOn\')" ng-class="{\'current\' : mobile.filterOn}" title="סינון תוצאות">סינון תוצאות</a></li><li class="swiper-slide"><a ng-click="mobile.toggleFilters(\'searchOn\')" ng-class="{\'current\' : mobile.searchOn}" title="חיפוש">חיפוש</a></li></ul></div></div></nav>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Filters/Search/Views/_Search.tpl.html',
    '<div id="search-filter" class="filter-strip" ng-class="{\'open\': search.searchOn}"><div class="search-area"><autocomplete on-enter="search.getResults" on-type="search.searchHues" on-select="search.getSingleResult" ng-model="yourchoice" data="options" attr-placeholder="חיפוש לפי שם קוד/ גוון"></autocomplete><button><i class="na-search"></i> <span>חפש</span></button></div></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Filters/Sub-Categories/Views/_sub-categories.html',
    '<div class="wood-filters" ng-class="{ \'loading\': subcategories.handler.loading }"><select scroll-to class="black" ng-repeat="subcategory in subcategories.handler.subcategories" ng-change="subcategories.handler.selectSubcat( this )" ng-model="option" ng-options="option.term_id as option.name for option in subcategory"></select></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Hues/Main/Templates/_hue.tpl.html',
    '<div class="fan archive item-wrapper" ui-sref-active="chosen"><div class="hue"><a ui-sref=".hue({hue_code: ( hue.hue_code | spaceless )})" class="the-hue" ng-style="{\'background-color\': hue.hue_hexadecimal ? \'#\'+hue.hue_hexadecimal : \'\', \'background-image\': hue.texture ? \'url(\' + ( hue.texture | thumb )+ \')\' : hues.texture ? \'url(\' + ( hues.texture | thumb ) + \')\' : hue.hue_img ? \'url(\' + ( hue.hue_img | thumb ) + \')\' : \'\'}" onclick="GA.send(\'Shades Fan\', \'Choose Shade\');"><span>{{hue.hue_code}}</span></a><div class="info"><div class="wishlist"><i class="na-heart-small" data-wishlist="hues" data-id="{{hue.ID}}"></i> <i class="na-drop-small" data-wishlist="samples" data-id="{{hue.ID}}" data-fan="{{hue.neutral_fan_id ? hue.neutral_fan_id : hues.neutral_fan_id ? hues.neutral_fan_id : null}}"></i></div><p><a ui-sref=".hue({hue_code: ( hue.hue_code | spaceless )})" title="{{hue.name}}">{{hue.name}}</a> <span>מניפת {{hue.fan}}</span></p></div></div><single-hue ng-if="hues.single === hue.hue_code"></single-hue></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Hues/Main/Views/_hues.tpl.html',
    '<div class="the-fans" ng-class="{loading: hues.loading}" infinite-scroll="hues.loadMorehues()" infinite-scroll-disabled="hues.loading || hues.busy" infinite-scroll-use-document-bottom="true"><hue ng-repeat="hue in hues.hues"></hue><div ng-if="hues.busy" class="load-more loading" style="height: 100px; width: 100%"></div><p ng-if="hues.not_found">לא נמצאו גוונים המתאימים לשילוב שהוזן</p></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Hues/Main/Views/_the-fans.tpl.html',
    '<div class="the-fans" ng-hide="fans.hide"><div class="container"><div class="save-and-current"><div ui-view="breadcrumbs"></div><div ui-view="save-fan"></div></div><div ui-view="hues"></div></div></div>');
}]);
})();

(function(module) {
try {
  module = angular.module('FansPartials');
} catch (e) {
  module = angular.module('FansPartials', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('Hues/Save-Fan/Views/_save-fan.tpl.html',
    '<div class="save-fan" onclick="$(this).toggleClass(\'open\')" ng-if="save.files && save.hasHues"><i class="na-save"></i> <span>שמירת גווים ממניפה זאת</span><div class="tooltip right"><ul><li ng-repeat="file in save.files"><a href="{{file.file_url}}" download>{{file.format}}</a></li></ul></div></div>');
}]);
})();

var SharedMdl = angular.module( 'Shared', [] );

SharedMdl.directive('isResolve', [ '$transitions', function($transitions){
	return {
		restrict: 'A',
		link: function( scope, element, attrs ){
			$transitions.onStart({}, function ( transition ) {

				var views = transition.views();

				angular.forEach(views, function(view){
					if ( view.viewDecl.$uiViewName === 'filters' && !transition.$from().abstract )
						return;

					if ( view.viewDecl.$uiViewName != attrs.uiView )
						return;


					element.addClass('loading');
				});
			});
			$transitions.onFinish({}, function (transition) {
				//self.loading = false;
				//console.log(transition.Views())
				//element.removeClass('loading');
			});
		}
	}
}]);
SharedMdl.directive('scrollToFans', [ '$transitions', function($transitions){
	return {
		restrict: 'A',
		link: function( scope, element, attrs ){
			//$transitions.onStart({}, function ( transition ) {
			//	//console.log(transition.params('to', 'from'))
			//	if ( transition.$to().name === 'main.categories.families.colors' || transition.$to().name === 'main.categories.families.effects.colors' ) {
			//		if( ( transition.params().color_fan_slug && transition.params().effect_fan_slug ) || transition.params().color_fan_slug ){
			//
			//		}
			//	}
			//})
		}

	}

}]);

SharedMdl.directive('swiper',[ '$timeout', function( $timeout ) {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			$timeout(function () {

			if ( scope.$last === true || scope.mobile ) {

				var id = element.closest('.filter-strip').attr('id');


				var swiper = new Swiper( '#' + id + ' .swiper-container', {
					paginationClickable: true,
					slidesPerView: 'auto',
					nextButton: '#' + id + ' .swiper-button-next',
					prevButton: '#' + id + ' .swiper-button-prev',
					direction: 'horizontal',
					onInit: function ( swiper ) {
						if( swiper.virtualSize > swiper.width )
							swiper.wrapper.css('justify-content', 'flex-start');
						else
							swiper.wrapper.css('justify-content', 'center');
					},
					initialSlide: ( function(){

						/**
						 * Due to scope issues..
						 * If the current class is on the last element, it can't be detected through a selector.
						 * The good news is that if we didn't find any current class in other elements it must be on the last one.
						 * @type {*|jQuery}
						 */
						var index = $('#' + id + ' .swiper-slide.current').index();

						return index !== -1 ? index : element.index();

					})()
				});


			}
			});
		}
	}
}]);
SharedMdl.filter('spaceless',function() {
	return function(input) {
		if (input) {
			return input.replace(/\s+/g, '_');
		}
	}
});
SharedMdl.service('UtilsSrv', [function(){
	// left: 37, up: 38, right: 39, down: 40,
	// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
	var scroll_keys = {37: 1, 38: 1, 39: 1, 40: 1};
	function fansPreventDefault(e) {
		e = e || window.event;
		if (e.preventDefault)
			e.preventDefault();
		e.returnValue = false;
	}



	return {

		/**
		 * Gets an object from a giving array by slug
		 * @param Array filterArr
		 * @param String currentFilterName
		 * @returns {Object}
		 */
		getFilterObj: function( filterArr, filterSlug ) {
			var filterObj = filterArr.filter(function( value ){
				return value.slug == filterSlug;
			})[0];

			return filterObj;
		},




		isArray: function( someVar ) {
			return Object.prototype.toString.call( someVar ) === '[object Array]'
		},

		scrollHandler: {
			preventDefaultForScrollKeys: function( e ) {
				if (scroll_keys[e.keyCode]) {
					fansPreventDefault(e);
					return false;
				}
			},

			disableScroll: function () {
				if (window.addEventListener) // older FF
					window.addEventListener('DOMMouseScroll', fansPreventDefault, false);
				window.onwheel = fansPreventDefault; // modern standard
				window.onmousewheel = document.onmousewheel = fansPreventDefault; // older browsers, IE
				window.ontouchmove  = fansPreventDefault; // mobile
				document.onkeydown  = this.preventDefaultForScrollKeys;
			},

			enableScroll: function() {
				if (window.removeEventListener)
					window.removeEventListener('DOMMouseScroll', fansPreventDefault, false);
				window.onmousewheel = document.onmousewheel = null;
				window.onwheel = null;
				window.ontouchmove = null;
				document.onkeydown = null;
			},

			scrollToFans: function() {
				var self = this,
				$fans = angular.element( document.querySelector('.the-fans .container') );

				this.disableScroll();

				$('html, body').animate({ scrollTop: $fans.offset().top }, 800, function(){
					self.enableScroll();
				});
			}

		}
	}
}]);

var FiltersMdl = angular.module( 'FansFilters', ['autocomplete', 'Shared', 'Hues'] );
FiltersMdl.controller( 'CategoriesCtrl', [ '$scope', '$state', 'categories', 'category', 'HuesSrv', 'HuesUpdaterSrv', function ( $scope, $state, categories, category, HuesSrv, HuesUpdaterSrv ) {



	this.categories = categories;
	HuesSrv.setFilter('category', category );
	HuesSrv.setFilter('effect_fan', false );
	HuesSrv.setFilter('color_fan', false );
	HuesSrv.setFilter('subcategory', false );


	/**
	 * Handle active class color.
	 * Determined by the current category.
	 */
	var colors = ['yellow', 'pink', 'blue', 'green'];

	$scope.filters.current_color = colors[ categories.indexOf( category ) ];
	HuesUpdaterSrv.current_color = $scope.filters.current_color;

}]);
FiltersMdl.directive( "category", [ '$compile', '$templateCache', function( $compile, $templateCache ) {
	return {
		restrict: 'E',
		replace: true,
		template: $templateCache.get( 'Filters/Categories/Templates/_category.tpl.html' ),
		//scope: {},
		//controller: ['$scope', function( $scope ) {
		//	this.state = 'main.categories';
		//	//console.log($scope);
		//}],
		//controller : '@',
		//name : 'myController',
		//controllerAs: 'category_state',
		//compile: function( element, attrs ) {
		//	return {
		//		pre: function( scope, element, attrs  ) {
		//
		//
		//		},
		//		post: function(scope, element, attrs ) {
		//			element.attr('ui-state', 'main.categories({category_slug: ' + scope.category.slug + '})');
		//			//return $compile(element);
		//		}
		//	}
		//},
		controller: [ '$scope', function( $scope ){
			var states = {
				'color-fans': 'main.categories.families.colors',
				'effect-fans': 'main.categories.families.effects',
				'categories-select': 'main.categories.subcategories'
			};



			this.state = states[ $scope.category.filter_through ];
		}],
		controllerAs: 'category_state',
		//scope: {},
		bindToController: true,
		link: function( scope, element, attrs ) {
			//console.log(scope)
			//vm.category_state = 'main.categories';
			//console.log(myController)
			//console.log(category)
			//this.category_state = 'main.categories';
			//myController.category_state = 'main.categories';

		}
	}
}]);
FiltersMdl.service( 'CategoriesSrv', ['$http', '$q', 'API_URL', function ( $http, $q, API_URL ) {

	var categories = null;


	return {
		/**
		 * Get product-categories that defined as related to fan app.
		 * Singleton.
		 * @returns {*}
		 */
		getCategories: function ( ) {
			var deffered = $q.defer();
			if ( categories )
				deffered.resolve( categories );
			else{
				$http.get( API_URL.FILTER + '/category/hue' ).then(
					function( response ){
						categories = response.data;
						deffered.resolve( categories );
					},
					function( error ) {
						deffered.reject(error);
					}
				)
			}
			return deffered.promise;
		}
	}
}]);

FiltersMdl.controller( 'ColorFansCtrl', [ '$scope', '$state', '$timeout', '$element', 'color_fans', 'color_fan', 'HuesSrv', 'HuesUpdaterSrv',
	function ( $scope, $state, $timeout, $element, color_fans, color_fan, HuesSrv, HuesUpdaterSrv ) {

	this.color_fans = color_fans;

	////If there is no specific selected fan, pass all fans.
	HuesSrv.setFilter('color_fan', color_fan ? color_fan : color_fans );


	//HuesSrv.setFilter('hue', false );
	HuesUpdaterSrv.isSearch = false;
	HuesSrv.setFilter('search_term', false );
	HuesSrv.setFilter('search_single', false );

}]);

FiltersMdl.directive( "colorFan", ['$templateCache', 'UtilsSrv', function( $templateCache, UtilsSrv ) {
	return {
		restrict: 'E',
		replace: true,
		template: $templateCache.get('Filters/Color-Fans/Templates/_color-fan.tpl.html'),
		link: function( scope, element ) {


				//element.on('click', function(e){
				//
				//});

					//console.log(element)

			//$timeout(function () {
			//	element.on('click', function(){
			//		console.log('fff')
			//		//UtilsSrv.scrollHandler.scrollToFans();
			//	})
			//});

		}
	}
}]);

FiltersMdl.service( 'ColorFansSrv', ['$http', '$q', 'API_URL', function ( $http, $q, API_URL ) {

	var product_cat = null,
		effect_fan = null,
		colorFans = null;


	return {

		getColorFansByProductCat: function( product_cat_id ) {
			var deffered = $q.defer();


			if ( colorFans && product_cat == product_cat_id )
				deffered.resolve( colorFans );
			else {
				product_cat = product_cat_id;
				effect_fan = null;

				$http.get( API_URL.FAN + '/colors/' + product_cat_id ).then(
						function (response){
							colorFans = response.data;
							deffered.resolve( colorFans );
						},
						function (error){
							deffered.reject(error);
						}
				);
			}

			return deffered.promise;
		},

		getColorFansByEffectFan: function( effect_fan_id ) {
			var deffered = $q.defer();

			if ( colorFans && effect_fan == effect_fan_id )
				deffered.resolve( colorFans );
			else {
				effect_fan = effect_fan_id;
				product_cat = null;

				$http.get( API_URL.FAN + '/colors/effect/' + effect_fan_id ).then(
						function (response){
							colorFans = response.data;
							deffered.resolve( colorFans );
						},
						function (error){
							deffered.reject(error);
						}
				);
			}

			return deffered.promise;
		},
	}
}]);



FiltersMdl.controller('EffectFans', [ '$scope', '$state', 'effect_fans', 'effect_fan', 'HuesSrv', function ( $scope, $state, effect_fans, effect_fan, HuesSrv ) {

	this.effect_fans = effect_fans;

	HuesSrv.setFilter('search_term', false );
	HuesSrv.setFilter('search_single', false );
	HuesSrv.setFilter('effect_fan', effect_fan ? effect_fan : effect_fans );





	//If the sate has an active child state, the child state handles the hue request (see ColorFansCtrl)
	if ( $state.current.name !== 'main.categories.families.effects' )
		return;


	HuesSrv.setFilter('color_fan', false );




}]);

FiltersMdl.directive( "effectFan", ['$templateCache', function( $templateCache ) {
	return {
		restrict: 'E',
		replace: true,
		template: $templateCache.get('Filters/Effect-Fans/Templates/_effect-fan.tpl.html'),
		controller: [ '$scope', function( $scope ){
			var states = {
				'monovalent-effect-fan': 'main.categories.families.effects',
				'neutral-effect-fan': 'main.categories.families.effects.colors',
				'neutral-schlicht-fan': 'main.categories.families.effects.colors'
			};



			this.state = states[ $scope.fan.fan_type ];
		}],
		controllerAs: 'effect_fan_state',
		bindToController: true
	}
}]);

FiltersMdl.service( 'EffectFansSrv', ['$http', '$q', 'API_URL', function ( $http, $q, API_URL ) {

	var product_cat = null,
		effectFans = null;


	return {

		getEffectFans: function( product_cat_id ) {
			var deffered = $q.defer();

			if ( effectFans && product_cat == product_cat_id )
				deffered.resolve( effectFans );
			else {
				product_cat = product_cat_id;

				$http.get( API_URL.FAN + '/effects/' + product_cat_id ).then(
						function (response){
							effectFans = response.data;
							deffered.resolve( effectFans );
						},
						function (error){
							deffered.reject(error);
						}
				);
			}

			return deffered.promise;
		}
	}
}]);




FiltersMdl.directive( "family", ['$templateCache', 'UtilsSrv', function( $templateCache, UtilsSrv ) {
	return {
		restrict: 'E',
		replace: true,
		template: $templateCache.get('Filters/Families/Templates/_family.tpl.html'),
		link: function( scope, element ) {
			element.on('click', function(){
				UtilsSrv.scrollHandler.scrollToFans();
			})
		}
	}
}]);

FiltersMdl.service( 'FamiliesSrv', ['$http', '$q', 'API_URL', function ( $http, $q, API_URL ) {

	var families = null;


	return {

		/**
		 * Get all hues families.
		 * Singleton.
		 * @returns {*}
		 */
		getFamilies: function() {
			var deffered = $q.defer();
			if ( families )
				deffered.resolve( families );
			else{
				$http.get( API_URL.FILTER + '/family/hue').then(
					function (response){
						families = response.data;
						deffered.resolve( families );
					},
					function (error){
						deffered.reject(error);
					}
				)
			}
			return deffered.promise;
		},
	}
}]);


FiltersMdl.controller( 'FamiliesCtrl', [ '$scope', '$state', 'families', 'family', 'HuesSrv', function ( $scope, $state, families, family, HuesSrv ) {

	this.families = families;
	HuesSrv.setFilter('family', family ? family : null );


}]);

FiltersMdl.controller( 'MobileCtrl', ['MobileFiltersSrv', function ( MobileFiltersSrv ) {

	this.filterOn = true;
	this.searchOn = false;

	this.toggleFilters = function( display_filter ) {

		if ( display_filter === 'filterOn') {
			this.filterOn = !this.filterOn;
			this.searchOn = false;
		}
		else {
			this.searchOn = ! this.searchOn;
			this.filterOn = false;
		}


		MobileFiltersSrv.filterOn = this.filterOn;
		MobileFiltersSrv.searchOn = this.searchOn;

	}
}]);



FiltersMdl.service( 'MobileFiltersSrv', [function() {
	return {

		filterOn: true,
		searchOn: false

	}
}]);
FiltersMdl.controller( 'SearchCtrl', [ '$scope', 'API_URL', '$http', 'MobileFiltersSrv', 'HuesUpdaterSrv', 'HuesSrv', function ( $scope, API_URL, $http, MobileFiltersSrv, HuesUpdaterSrv, HuesSrv ) {
	var self = this,
		searchResults = false;

	this.searchOn = false;


	/**
	 * Watcher for a service value changes.
	 * This value is being updating by other controllers on runtime according to the user actions on the page
	 * after the states has being loaded.
	 */
	$scope.$watch(function () { return MobileFiltersSrv.searchOn;}, function( searchOn ){
		self.searchOn = searchOn;
	});


	$scope.options = [];

	var search_input = '';

	this.searchHues = function( input ) {
		if( input.length < 2 )
			return;


		search_input = input;
		$http.get( API_URL.HUE + '/search-hue/' + input + '/type/name' ).then(
				function ( response ) {
					searchResults = response.data;
					if( searchResults.length ) {
						$scope.options = searchResults.map(function (item) {
							return item['hue'];
						});
					} else
						$scope.options = [];

				},
				function (error){
					console.log( error );
				}
		);
	};

	this.getResults = function(){

		if( search_input < 2 )
			return;

		processSearch();
		HuesSrv.setFilter('search_term', search_input );
		HuesSrv.setFilter('search_single', false );
		HuesUpdaterSrv.getHues = true;
	};

	this.getSingleResult = function( selected ){

		var hue_id = searchResults.filter(function (item) {
			return item['hue'] == selected;
		})[0].ID;


		processSearch();
		HuesSrv.setFilter('search_term', false );
		HuesSrv.setFilter('search_single', hue_id );
		HuesUpdaterSrv.getHues = true;
	};

	function processSearch() {
		$('html, body').animate({ scrollTop: angular.element('.the-fans .container').offset().top }, 800, function(){});
		HuesUpdaterSrv.isSearch = true;
		HuesUpdaterSrv.getHues = false;
		HuesSrv.setFilter('category', false );
		HuesSrv.setFilter('family', false );
		HuesSrv.setFilter('color_fan', false );
		HuesSrv.setFilter('effect_fan', false );
		HuesSrv.setFilter('subcategory', false );
		HuesSrv.setFilter('hue', false );

	}


	angular.element('.search-area button').on('click', self.getResults );




}]);


FiltersMdl.service( 'SearchSrv', ['$q', '$http', 'API_URL', 'HuesSrv', 'HuesUpdaterSrv',
	function( $q, $http, API_URL, SubcategoriesFcty, HuesSrv, HuesUpdaterSrv ) {

	var searchResults = [];

	return {

		setScope: function( scope ) {
			this.scope = scope;
		},
		//scope: false,

		//options: [],

		searchHues: function( input ) {
			console.log(this.scope);
			return;

			if( input.length < 2 )
				return;


			var self = this;
			//this.scope.options = [];

			$http.get( API_URL.HUE + '/search-hue/' + input ).then(
					function ( response ) {
						searchResults = response.data;
						if( searchResults.length ) {
							self.scope.options = searchResults.map(function (item) {
								return item['hue'];
							});
						} else
							self.scope.options = [];


						console.log(self.scope.options);


					},
					function (error){
						console.log( error );
					}
			);
		},

		setResults: function(){
			console.log('setResults')
		},

		showResults: function() {
			console.log('showResults')
		}
	}


}]);
FiltersMdl.controller( 'SubCategoriesCtrl', [ 'SubcategoriesHandlerSrv', 'category', 'sub_category', 'HuesSrv', function ( SubcategoriesHandlerSrv, category, sub_category, HuesSrv ) {



	HuesSrv.setFilter('color_fan', false );
	HuesSrv.setFilter('effect_fan', false);
	HuesSrv.setFilter('family', false );




	this.handler = SubcategoriesHandlerSrv;
	this.handler.subcategories = [ sub_category ];
	this.handler.category = category;



}]);
FiltersMdl.directive( "scrollTo", ['$window', function( $window ) {
	return {
		restrict: 'A',
		link: function( scope, element ) {
			element.bind('change', function(){

				if( $window.innerWidth > 1024 )
					return;

				$('html, body').animate({ scrollTop: angular.element( this ).offset().top }, 800);
			})
		}
	}
}]);

/**
 * Subcategories factory:
 *
 * Handle the logic of subcategories.
 *
 * Subcategories appears in a few places:
 * Fans page - when selecting the "wood" category,
 * Products-Catalog - when selecting a category from the list & when we have a chosen hue.
 *
 * The subcategories are being used as another filter after choosing a product category.
 * ( Reminder: even hues at the fan page are being filtered by products categories )
 *
 *
 */
FiltersMdl.factory( 'SubcategoriesFcty', [ '$http', '$q', 'API_URL', 'SubcategoriesSrv', function ( $http, $q, API_URL, SubcategoriesSrv ){

	/*
	*Array that holds all the selected subcategories.
	* Being used in case we need to know what was the previous selection in case the user
	* has selected one of the previous select boxes.
	* */
	var selectedSubCategories = [];

	var PROPERTIES = {
		category: null,
		loading: false,
		subcategories: []
	};

	function Subcategories( config ) {
		angular.extend(this, PROPERTIES, config);
	}


	Subcategories.prototype = {
		constructor: Subcategories,

		/**
		 * Being executed on selection of one of the options in the subcategories section.
		 * The "scope" properties that being used are the index of the select box and the value of the option.
		 * @param scope
		 */
		selectSubcat : function( scope ) {
			var self = this;

			GA.send('Shades Fan', 'Filter');
			//Removes all items after selection, new options would be generated with every selection.
			this.subcategories = this.subcategories.slice( 0, scope.$index + 1 );
			selectedSubCategories = selectedSubCategories.slice( 0, scope.$index + 1 );

			//Check if the selected option has a value ( not just a title of a select box ):
			if ( scope.option ) {
				this.loading = true;

				//Set selection value as the same index of options.
				selectedSubCategories[scope.$index] =  scope.option;

				//Get the next subcategories:
				SubcategoriesSrv.getSubCategories( scope.option ).then (
					function( subcategories ){
						self.loading = false;
						if ( subcategories )
							self.subcategories.push( subcategories );

					});

				//Get items by category ( products/hues ect.. that method should be implementing by an instance of that factory )
				this.getItems(scope.option);
			} else {
				selectedSubCategories.splice( scope.$index, 1 );
				this.getItems( selectedSubCategories[ selectedSubCategories.length - 1 ] ? selectedSubCategories[ selectedSubCategories.length - 1 ] : this.category.id )
			}


		}
	};



	return Subcategories;

}]);
FiltersMdl.service( 'SubcategoriesHandlerSrv', ['$q', '$http', 'API_URL', 'SubcategoriesFcty', 'HuesSrv', 'HuesUpdaterSrv', function( $q, $http, API_URL, SubcategoriesFcty, HuesSrv, HuesUpdaterSrv ) {
	return new SubcategoriesFcty({

		getItems: function( category_id ) {
			HuesUpdaterSrv.getHues = false;
			if( category_id == this.category.id ) {
				HuesUpdaterSrv.hideHues = true;
			} else {
				HuesSrv.setFilter('search_term', false );
				HuesSrv.setFilter('search_single', false );
				HuesSrv.setFilter('subcategory', category_id );
				HuesUpdaterSrv.hideHues = false;
				HuesUpdaterSrv.getHues = true;
			}




		}
	});
}]);

FiltersMdl.service( 'SubcategoriesSrv', [ '$q', '$http', 'API_URL', function( $q, $http, API_URL ) {

	return {
		getSubCategories: function ( category_id ) {
			var deffered = $q.defer();
			$http.get( API_URL.FILTER + '/sub_categories/' + category_id ).then(
				function(response) {
					deffered.resolve(response.data);
				},
				function (error){
					deffered.reject(error);
				}
			);
			return deffered.promise;
		}
	};
}]);
FiltersMdl.controller( 'FiltersCtrl', ['$scope', '$element', 'MobileFiltersSrv', function( $scope, $element, MobileFiltersSrv ) {

	var self = this;


	this.filterOn = true;
	this.current_color = 'yellow';

	/**
	 * Watcher for a service value changes.
	 * This value is being updating by other controllers on runtime according to the user actions on the page
	 * after the states has being loaded.
	 */
	$scope.$watch(function () { return MobileFiltersSrv.filterOn;}, function( filterOn ){
		self.filterOn = filterOn;
	});



}]);

FiltersMdl.controller( 'InnerFiltersCtrl', [ function() {}]);
var HuesMdl = angular.module( 'Hues', ['Shared', 'infinite-scroll'] );
HuesMdl.controller( 'BreadcrumbsCtrl', ['$scope', 'category', 'family', 'effect_fan', 'color_fan', 'HuesUpdaterSrv',
	function ( $scope, category, family, effect_fan, color_fan, HuesUpdaterSrv ) {


	var self = this,
	defaultValues = {
		family: 'כל משפחות הגוונים',
		color_fan: 'כל מניפות הגוונים',
		effect_fan: 'כל סוגי האפקטים'
	},
	breadcrumbs = [
		category.name,
		( family === false ) ? false : ( family === null ) ? defaultValues.family : family.name,
		( effect_fan === false ) ? false : ( effect_fan === null ) ? defaultValues.effect_fan : effect_fan.name,
		( color_fan === false ) ? false : ( color_fan === null ) ? defaultValues.color_fan : color_fan.name
	].filter( Boolean );

	this.breadcrumbs = breadcrumbs;

	$scope.$watch(function () { return HuesUpdaterSrv.isSearch;}, function( isSearch ){

		self.breadcrumbs = isSearch ? ['תוצאות חיפוש'] : breadcrumbs;

	});

	$scope.$watch(function () { return HuesUpdaterSrv.current_color;}, function( current_color ){

		self.current_color = current_color;

	});
}]);

/**
 * Pagination Factory
 *
 * Contains general properties and methods related to lazy load data from the server to increase
 * single page application performances.
 *
 * This factory is meant to be a class, other factories should create instances out of it.
 */
HuesMdl.factory( 'PaginationFcty', ['$http', '$q', function ( $http, $q ) {

	var HANDLERS = {
		API_URL: '',
		limit: 0,
		offset: 0,
		results: false,
		no_results: false,
		last_page: false
	};

	function Pagination(config) {
		angular.extend(this, HANDLERS, config);
	}

	Pagination.prototype = {
		constructor: Pagination,

		getResults: function() {
			var self = this,
				deffered = $q.defer();

			if( this.no_results || this.last_page ) {
				deffered.reject('no results');
				return deffered.promise;
			}

			$http.get( this.API_URL + '/limit/' + this.limit + '/offset/' + this.offset ).then(
				function ( response ) {
					if( response.data.length ) {
						self.results = self.results ? self.results : [];
						self.results = response.data;
						self.offset = self.offset + self.limit;


						if ( response.data.length < self.limit )
							self.last_page = true;

						deffered.resolve( self.results );
					}
					else {
						self.no_results = true;
						deffered.reject();
					}
				},
				function( error ) {
					deffered.reject(error);
				}
			);
			return deffered.promise;
		},

		resetHandlers: function() {
			this.results = false;
			this.offset = 0;
			this.API_URL = '';
			this.no_results =  false;
			this.last_page = false;
		}
	};

	return Pagination;
}]);
HuesMdl.filter('thumb',function() {
	return function(input) {
		if (input) {
			return input.replace(/.([^.]*)$/, "-180x180.$1");
		}
	}
});
HuesMdl.service( 'HuesSrv', ['$rootScope', 'PaginationFcty', 'UtilsSrv', '$http', '$q', 'API_URL', function ( $rootScope, PaginationFcty, UtilsSrv, $http, $q, API_URL ) {

	//var filters = {
	//	category: null,
	//	family: null,
	//	color_fan: null,
	//	effect_fan: null,
	//	subcategory: null
	//};



	return new PaginationFcty({

		limit :24,


		filters: {
			category: false,
			family: false,
			color_fan: false,
			effect_fan: false,
			subcategory: false,
			hue: false,
			search_term: false,
			search_single: false
		},

		/**
		 * Array of promises
		 */
		filterQueue: [],


		/**
		 * Each filter is being set by it's own matched controller.
		 * After being set, a defer object is being pushed to the filter queue.
		 * That way we can get hues by filter only after all the filter has been set.
		 * @param filterName
		 * @param filterValue
		 */
		setFilter: function( filterName, filterValue ) {
			var filter = $q.defer();
			this.filters[ filterName ] = filterValue;
			filter.resolve();
			this.filterQueue.push( filter.promise )
		},


		getFilters: function() {
			return this.filters;
		},

		buildFanPath: function( fan ) {
			var path = '/' + fan.replace('_', '-'),
				fan_ids = UtilsSrv.isArray( this.filters[ fan ] ) ? this.filters[ fan ].map(function(fan) {return fan.id}).join(',') : this.filters[ fan ].id ;

			return path + '/' + fan_ids;
		},

		buildQuery: function() {


			var family_path = ( this.filters.family ) ? '/family/' + this.filters.family.id : '',
				color_fan_path = ( this.filters.color_fan ) ? this.buildFanPath( 'color_fan' ) : '',
				effect_fan_path = ( this.filters.effect_fan && ! this.filters.color_fan) ? this.buildFanPath( 'effect_fan' ) : '',
				neutral_fan_path = ( this.filters.effect_fan && this.filters.color_fan ) ? '/neutral-fan/' + this.filters.effect_fan.id : '',
				category_path = ( this.filters.subcategory ) ? '/category/' + this.filters.subcategory : '',
				hue_path = ( this.filters.hue ) ? '/hue/' + this.filters.hue : '',
				search_path = ( this.filters.search_term ) ? '/search-hue/' + this.filters.search_term + '/type/full' : '',
				search_single = ( this.filters.search_single ) ? '/search-hue/' + this.filters.search_single + '/type/single' : '';

			return API_URL.HUE + '/by'+ family_path + effect_fan_path + neutral_fan_path + color_fan_path + category_path + hue_path + search_path + search_single;

		},


		getHues: function() {
			var self = this,
				huePromise = $q.defer();

			this.resetHandlers();


			$q.all(this.filterQueue).then( function(){
				self.API_URL = self.buildQuery();
				self.getResults().then(
					function(hues){
						huePromise.resolve( hues );
					},
					function(error){
						huePromise.reject();
					});
			});

			return huePromise.promise;

		}

	});

}]);

HuesMdl.service( 'RedirectSrv', ['$location', 'SITE_URL', function ( $location, SITE_URL ) {

	var redirect_url = false;

	return {
		setRedirect: function() {
			if(redirect_url)
				return;

			redirect_url = $location.search().redirect ? SITE_URL.URL + '/' + $location.search().redirect : false;
		},

		getRedirect: function() {
			return redirect_url;
		}
	}

}]);
HuesMdl.service( 'WishlistSrv', [function () {
	//var hueWishlist = new Wishlist( 'hues-wishlist', $('[data-wishlist=hues]') );
	var hueWishlist = false;
	return {


		getHueWislist : function() {
			if( hueWishlist )
				return hueWishlist;


			hueWishlist = new Wishlist( 'hues-wishlist', $('[data-wishlist=hues]') );
			//hueWishlist.init();
			return hueWishlist;


		}
	}
}]);

HuesMdl.controller( 'SingleHueCtrl', ['$scope', '$state', 'HuesSrv',  function ( $scope, $state, HuesSrv ) {

}]);

HuesMdl.directive( 'singleHue', [ '$document', '$templateCache', '$state', 'UtilsSrv', 'RedirectSrv', function( $document, $templateCache, $state, UtilsSrv, RedirectSrv ) {
	return {
		restrict: 'E',
		replace: true,
		template: $templateCache.get('Hues/Single/_single-hue.tpl.html'),
		link: function( scope, element ){

			console.log(RedirectSrv.getRedirect());

			scope.$parent.hue.redirect = RedirectSrv.getRedirect();


			/**
			 * Scroll to open single hue:
			 */
			UtilsSrv.scrollHandler.disableScroll();
			$('html, body').animate({ scrollTop: element.offset().top }, 800, function(){
				UtilsSrv.scrollHandler.enableScroll();
			});



			/**
			 * Exit Single State:
			 */
			function exitSingle( chosenHue ) {
				chosenHue = chosenHue || element.parent('.chosen');

				UtilsSrv.scrollHandler.disableScroll();
				$('html, body').animate({ scrollTop: chosenHue.offset().top }, 800, function(){
					UtilsSrv.scrollHandler.enableScroll();
				});

				//If we to exit from single hue, navigate to relative parent:
				$state.go('^');
			}


			$document.on("keydown keypress", function ( e ) {
				if( $('#overlay').css('display') === 'flex' )
					return;

				if( e.which === 27)
					exitSingle( angular.element( document.querySelector('.fan.archive.item-wrapper.chosen') ) );

				return;
			});

			element.find('.close-hue .na-close').on('click', function(){
				exitSingle();
			});

		}
	}
}]);

HuesMdl.controller( 'FansCtrl', ['$scope', 'hide', 'HuesUpdaterSrv', function ( $scope, hide, HuesUpdaterSrv ) {

	var self = this;

	this.hide = hide;

	$scope.$watch(function () { return HuesUpdaterSrv.hideHues;}, function( hideHues ){
		self.hide = hideHues;
	});
}]);

HuesMdl.controller( 'HuesCtrl', ['$scope', '$state', 'CATALOG_URL', 'HuesUpdaterSrv', 'HuesSrv', 'category', 'effect_fan',
	function ( $scope, $state, CATALOG_URL, HuesUpdaterSrv, HuesSrv, category, effect_fan ) {

	var self = this;

	this.loading = true;
	this.busy = false;
	this.hues = [];
	this.not_found = false;
	this.neutral_fan_id = false;
	this.single = $state.params.hue_code ? $state.params.hue_code.replace('_', ' ') : false;
	this.CATALOG_URL = CATALOG_URL.URL;
	this.isSearch = false;





	/**
	 * Watcher for a service value changes.
	 * This value is being updating by other controllers on runtime according to the user actions on the page
	 * after the states has being loaded.
	 */
	$scope.$watch(function () { return HuesUpdaterSrv.getHues;}, function( getHues ){

		if( getHues )
			self.getHues();
		else
			self.hues = [];

		HuesUpdaterSrv.getHues = false;
	});


	$scope.$watch(function () { return HuesUpdaterSrv.isSearch;}, function( isSearch ){
		self.isSearch = isSearch;
		if( isSearch) {
			self.texture = false;
			self.neutral_fan_id = false;
		}
	});





	this.getHues = function() {

		this.loading = true;
		this.not_found = false;
		HuesSrv.getHues().then(
				function( hues ) {
					singleHueWatch();
					if( singleStateHandler( hues ) ) {
						self.hues = hues;
						HuesUpdaterSrv.hasHues = true;
						self.loading = false;
					}
				}, function() {
					self.not_found = true;
					self.loading = false;
				}
		);
	};




	if( effect_fan && ( effect_fan.fan_type === "neutral-effect-fan" || effect_fan.fan_type === "neutral-schlicht-fan" ) ) {
		this.texture = effect_fan.texture;
		this.neutral_fan_id = effect_fan.id;
		this.neutral_fan_slug = effect_fan.slug;
	}



	/**
	 * Load more hues when the user scrolls to document bottom.
	 */
	this.loadMorehues = function() {
		if ( this.busy || this.loading ) return;


		this.busy = true;

		HuesSrv.getResults().then(
				function( hues ) {
					self.hues = self.hues.concat( hues );
					self.busy = false;
				},
				function() {
					self.busy = false;
				}
		);

	};



	if ( category.filter_through !== 'categories-select' )
		this.getHues();






	function singleHueWatch(){
		$scope.$watch(function () { return $state.params.hue_code; }, function ( single, oldSingle ) {

			if( typeof single === 'undefined' ) {
				self.single = false;
				return;
			}


			self.single = single.replace('_', ' ');
		});
	}



	function singleStateHandler( hues ){
		if( self.isSearch )
			return true;

		/**
		 * We are not in single state,
		 * Or we are in a category filtered by select boxes ( not shown in state params ) can proceed.
		 */

		if( ! self.single || ( category.filter_through === 'categories-select' ))
			return true;



		var huesCodes = hues.map(function(hue){return hue.hue_code});





		//The single hue that was passed as a parameter is in the hue list, can proceed and handle it.
		if ( huesCodes.indexOf( self.single ) !== -1 )
			return true;


		HuesSrv.setFilter('hue', self.single.replace(' ', '_'));
		$state.reload();

	}
}]);
HuesMdl.directive( "hue", [ '$compile', '$templateCache', '$stateParams', '$location', 'API_URL', function( $compile, $templateCache, $stateParams, $location, API_URL ) {
	return {
		restrict: 'E',
		replace: true,
		template: $templateCache.get('Hues/Main/Templates/_hue.tpl.html'),
		link: function(scope) {
			var neutral_fan_slug = scope.hue.neutral_fan_slug ? '/' + scope.hue.neutral_fan_slug : scope.$parent.hues.neutral_fan_slug ? '/' + scope.$parent.hues.neutral_fan_slug : '' ;

			scope.hue.print_url = API_URL.PRINT + '/' + scope.hue.ID + neutral_fan_slug;

			scope.location = $location;
			scope.$watch( 'location.url()', function( url ) {
				scope.hue.mail_url = $location.$$absUrl;
			});

		}
	}
}]);
/**
 * Wishlist Directive.
 *
 * Initialize wishlist object in angular based applications after we load dynamic content.
 *
 * Should be included on the container of the appropriate elements ( hues, products ) example:
 *
 * For further information see:
 *
 *  Core/List/List.js
 *
 */

HuesMdl.directive('wishlist',[ '$timeout', function( $timeout ) {

	return {
		restrict: 'A',
		link: function (scope) {
			if ( scope.$last === true ) {
				$timeout( function () {

					Samples.render();
					hueWishlist.render();
				});
			}
		}
	}

}]);
HuesMdl.service( 'HuesUpdaterSrv', [ function () {

	return {

		hideHues: false,
		getHues: false,
		isSearch: false,
		hasHues: false,
		current_color: 'yellow'
	}
}]);

HuesMdl.controller( 'SaveFanCtrl', ['$scope', 'effect_fan', 'color_fan', 'FanFilesSrv', 'HuesUpdaterSrv',
	function ( $scope, effect_fan, color_fan, FanFilesSrv, HuesUpdaterSrv ) {

	this.files = false;
	this.hasHues = false;

	var self = this,
		fan_id = ( effect_fan && color_fan ) ? color_fan.id : ( effect_fan &&  color_fan === false ) ? effect_fan.id : ( color_fan ) ? color_fan.id : false;

	if ( ! fan_id )
		return;

	$scope.$watch(function () { return HuesUpdaterSrv.hasHues;}, function( hasHues ){
		self.hasHues = hasHues;
	});
	FanFilesSrv.getFanFiles( fan_id ).then(
		function( files ) {

			if( files )
				self.files = files;

		}
	)




}]);

HuesMdl.service( 'FanFilesSrv',['$http', '$q', 'API_URL', function( $http, $q, API_URL ) {

	return {
		getFanFiles: function( fan_id ) {
			var deffered = $q.defer();

			$http.get( API_URL.FAN + '/files/' + fan_id ).then(
				function ( response ){
					deffered.resolve( response.data );
				},
				function (error){
					deffered.reject(error);
				}
			)

			return deffered.promise;
		}
	}
}]);

var FansMdl = angular.module( 'Fans', [ 'Shared', 'Hues', 'FansFilters', 'ui.router', 'FansPartials'] );

FansMdl
	.constant( 'API_URL', ( function() {

		return {
			PRINT: appConsts.apiUrl + '/print/hue',
			FILTER: appConsts.apiUrl + '/filter',
			FAN: appConsts.apiUrl + '/fan',
			HUE: appConsts.apiUrl + '/hue',
			PRODUCT: appConsts.apiUrl + '/product'
		}
	})())


	.constant( 'CATALOG_URL', { URL: appConsts.catalogUrl})
	.constant( 'SITE_URL', { URL: appConsts.site_url})
FansMdl.config( [ '$stateProvider', '$urlRouterProvider', function( $stateProvider, $urlRouterProvider) {



	$urlRouterProvider.when('', ['$state', function ( $state ) {
		$state.go( 'main.categories.families.colors' );
	}]);


	$stateProvider

		.state('main', {
			abstract: true,
			views: {
				'mobile-filters': {
					templateUrl: 'Filters/Mobile-Filters/Views/_mobile-filter.tpl.html',
					controller: 'MobileCtrl as mobile'
				},
				'search' : {
					templateUrl: 'Filters/Search/Views/_Search.tpl.html',
					controller: 'SearchCtrl as search'
				},
				'filters': {
					templateUrl: 'Filters/Main/Views/_Filters.tpl.html',
					controller: 'FiltersCtrl as filters'
				}
			},
			onEnter: ['RedirectSrv', function( RedirectSrv ){
				RedirectSrv.setRedirect();
			}],
		})

		.state('main.categories', {
			abstract: true,
			url: '/category/:category_slug',
			params: {
				category_slug: 'wall'
			},
			views: {
				'categories': {
					templateUrl: 'Filters/Categories/Views/_categories.tpl.html',
					controller: 'CategoriesCtrl as categories'
				},
				'inner-filters': {
					templateUrl: 'Filters/Main/Views/_inner-filters.tpl.html',
					controller: 'InnerFiltersCtrl as inner_filters'
				}
			},
			resolve: {
				categories:	[ 'CategoriesSrv', function( CategoriesSrv ) {
					return CategoriesSrv.getCategories();
				}],
				category: [ '$stateParams', 'UtilsSrv', 'categories', function( $stateParams, UtilsSrv, categories ){
					return UtilsSrv.getFilterObj( categories, $stateParams.category_slug);
				}]
			}

		})

		.state( 'main.categories.families', {
			abstract: true,
			url: '/family/:family_slug',
			params: {
				family_slug : null
			},
			views: {
				'families@main.categories': {
					templateUrl: 'Filters/Families/Views/_families.tpl.html',
					controller: 'FamiliesCtrl as families'
				}
			},
			resolve: {
				families: ['FamiliesSrv', function( FamiliesSrv ) {
					return FamiliesSrv.getFamilies();
				}],
				family: [ '$stateParams', 'UtilsSrv', 'families', function( $stateParams, UtilsSrv, families ){
					return $stateParams.family_slug ? UtilsSrv.getFilterObj( families, $stateParams.family_slug) : null;
				}]
			}
		})

		.state( 'main.categories.families.colors', {
			url: '/color-fan/:color_fan_slug',
			params: {
				color_fan_slug: {
					value: null,
					squash: true
				}
			},
			views: {
				'color-fans@main.categories': {
					templateUrl: 'Filters/Color-Fans/Views/_color-fans.tpl.html',
					controller: 'ColorFansCtrl as color_fans'
				},
				'the-fans@': {
					templateUrl: 'Hues/Main/Views/_the-fans.tpl.html',
					controller: 'FansCtrl as fans'
				},
				'breadcrumbs@main.categories.families.colors': {
					templateUrl: 'Hues/Breadcrumbs/_breadcrumbs.tpl.html',
					controller: 'BreadcrumbsCtrl as breadcrumbs'
				},
				'save-fan@main.categories.families.colors': {
					templateUrl: 'Hues/Save-Fan/Views/_save-fan.tpl.html',
					controller: 'SaveFanCtrl as save'
				},
				'hues@main.categories.families.colors': {
					templateUrl: 'Hues/Main/Views/_hues.tpl.html',
					controller: 'HuesCtrl as hues'
				}
			},
			resolve: {
				hide: ['category', function( category ){
					return ( category.filter_through === 'categories-select' );
				}],
				color_fans: ['ColorFansSrv', 'category', function( ColorFansSrv, category ) {
					return ColorFansSrv.getColorFansByProductCat( category.id );
				}],
				color_fan: [ '$stateParams', 'UtilsSrv', 'color_fans', function( $stateParams, UtilsSrv, color_fans ){
					return $stateParams.color_fan_slug ? UtilsSrv.getFilterObj( color_fans, $stateParams.color_fan_slug) : null;
				}],
				effect_fan: [function(){ return false; }]
			}
		})


		.state('main.categories.families.effects',{
			url: '/effect-fan/:effect_fan_slug',
			params: {
				effect_fan_slug: {
					value: null
				}
			},
			views: {
				'effect@main.categories' : {
					templateUrl: 'Filters/Effect-Fans/Views/_effect-fans.tpl.html',
					controller: 'EffectFans as effect_fans'
				},
				'the-fans@': {
					templateUrl: 'Hues/Main/Views/_the-fans.tpl.html',
					controller: 'FansCtrl as fans'
				},
				'breadcrumbs@main.categories.families.effects': {
					templateUrl: 'Hues/Breadcrumbs/_breadcrumbs.tpl.html',
					controller: 'BreadcrumbsCtrl as breadcrumbs'
				},
				'save-fan@main.categories.families.effects': {
					templateUrl: 'Hues/Save-Fan/Views/_save-fan.tpl.html',
					controller: 'SaveFanCtrl as save'
				},
				'hues@main.categories.families.effects': {
					templateUrl: 'Hues/Main/Views/_hues.tpl.html',
					controller: 'HuesCtrl as hues'
				}
			},
			resolve: {
				hide: ['category', function( category ){
					return ( category.filter_through === 'categories-select' );
				}],
				effect_fans: ['EffectFansSrv', 'category', function( EffectFansSrv, category ) {
					return EffectFansSrv.getEffectFans( category.id );
				}],
				effect_fan: [ '$stateParams', 'UtilsSrv', 'effect_fans', function( $stateParams, UtilsSrv, effect_fans ){
					return $stateParams.effect_fan_slug ? UtilsSrv.getFilterObj( effect_fans, $stateParams.effect_fan_slug ) : null;
				}],
				color_fan: [function(){ return false; }]
			}
		})

		.state('main.categories.families.effects.colors',{
			url: '/color-fan/:color_fan_slug',
			params: {
				color_fan_slug: {
					value: null
				}
			},
			views: {
				'color-fans@main.categories': {
					templateUrl: 'Filters/Color-Fans/Views/_color-fans.tpl.html',
					controller: 'ColorFansCtrl as color_fans'
				},
				'the-fans@': {
					templateUrl: 'Hues/Main/Views/_the-fans.tpl.html',
					controller: 'FansCtrl as fans'
				},
				'breadcrumbs@main.categories.families.effects.colors': {
					templateUrl: 'Hues/Breadcrumbs/_breadcrumbs.tpl.html',
					controller: 'BreadcrumbsCtrl as breadcrumbs'
				},
				'save-fan@main.categories.families.effects.colors': {
					templateUrl: 'Hues/Save-Fan/Views/_save-fan.tpl.html',
					controller: 'SaveFanCtrl as save'
				},
				'hues@main.categories.families.effects.colors': {
					templateUrl: 'Hues/Main/Views/_hues.tpl.html',
					controller: 'HuesCtrl as hues'
				}


			},
			resolve: {
				effect_fan: ['$stateParams', 'UtilsSrv', 'effect_fans', function( $stateParams, UtilsSrv, effect_fans ){
					return UtilsSrv.getFilterObj( effect_fans, $stateParams.effect_fan_slug );
				}],
				color_fans: ['ColorFansSrv', 'effect_fan', function( ColorFansSrv, effect_fan ) {
					return ColorFansSrv.getColorFansByEffectFan( effect_fan.id );
				}],
				color_fan: [ '$stateParams', 'UtilsSrv', 'color_fans', function( $stateParams, UtilsSrv, color_fans ){
					return $stateParams.color_fan_slug ? UtilsSrv.getFilterObj( color_fans, $stateParams.color_fan_slug) : null;
				}]
			}

		})

		.state('main.categories.subcategories',{
			url: '',
			onEnter: ['HuesUpdaterSrv', function( HuesUpdaterSrv ){
				HuesUpdaterSrv.hideHues = true;
				HuesUpdaterSrv.getHues = false;
			}],
			onExit: ['HuesUpdaterSrv', function( HuesUpdaterSrv ){
				HuesUpdaterSrv.hideHues = false;
			}],
			views: {
				'sub-categories@main.categories': {
					templateUrl: 'Filters/Sub-Categories/Views/_sub-categories.html',
					controller: 'SubCategoriesCtrl as subcategories'
				},
				'the-fans@': {
					templateUrl: 'Hues/Main/Views/_the-fans.tpl.html',
					controller: 'FansCtrl as fans'
				},
				'breadcrumbs@main.categories.subcategories': {
					templateUrl: 'Hues/Breadcrumbs/_breadcrumbs.tpl.html',
					controller: 'BreadcrumbsCtrl as breadcrumbs'
				},
				'hues@main.categories.subcategories': {
					templateUrl: 'Hues/Main/Views/_hues.tpl.html',
					controller: 'HuesCtrl as hues'
				}
			},
			resolve: {
				hide: ['category', function( category ){
					return ( category.filter_through === 'categories-select' );
				}],
				sub_category: ['SubcategoriesSrv', 'category', function( SubcategoriesSrv, category ){
					return SubcategoriesSrv.getSubCategories( category.id )
				}],
				family: [function(){ return false; }],
				effect_fan: [function(){ return false; }],
				color_fan: [function(){ return false; }]
			}
		})


		/**
		 * Single States:
		 */

		.state( 'main.categories.families.colors.hue',{
			url: '/hue/:hue_code'
		})
		.state( 'main.categories.families.effects.hue',{
			url: '/hue/:hue_code'
		})
		.state( 'main.categories.families.effects.colors.hue',{
			url: '/hue/:hue_code'
		})
		.state( 'main.categories.subcategories.hue',{
			url: '/hue/:hue_code'
		})


}])